/**
 * Booking information for displaying in tables and components across the application
 */
export class BookingInfo {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly startDate?: Date,
    public readonly endDate?: Date
  ) {}

  /**
   * Compare two BookingInfo objects for sorting
   * @param a First BookingInfo object
   * @param b Second BookingInfo object
   * @returns Comparison result (-1, 0, 1)
   */
  static compare(a: BookingInfo, b: BookingInfo): number {
    // Sort by name by default
    return a.name.localeCompare(b.name);
  }

  /**
   * Check if booking has dates defined
   * @returns true if both start and end dates are defined
   */
  public hasDates(): boolean {
    return !!(this.startDate && this.endDate);
  }
}
